module.exports = __webpack_public_path__ + "static/media/weather-application.8341aac2.PNG";